import {createRouter, createWebHistory} from 'vue-router'
import HomeView from '../views/HomeView.vue'
import handoff from '../views/handoff.vue'

const routes = [
    // 首页
    {
        path: '/',
        name: 'home',
        component: HomeView
    },
    {
        path: '/handoff',
        name: 'handoff',
        component: handoff
    },
    // 客服端
    {
        path: '/service',
        name: 'service',
        component: () => import('../views/serviceView.vue'),
        children: [
            // 单个导航====mainelement
            // 控制面板
            //   {
            //       path: '1',
            //       component: () => import('../components/MainElement/ControlView.vue'),
            // },
            {
                path: '',
                // component: () => import('../components/MainElement/ControlView1.vue'),
                component: () => import('../components/HomeView'),
            },

            {
                path: 'stayCollection',
                component: () => import('../components/CustomerElement/stayCollectionView.vue'),
            },
            {
                path: 'flowupinfo',
                component: () => import('../components/CustomerElement/FlowupInfomation/tabletitle.vue'),
            },

            // 调解员公海查看
            {
                path: 'lawseadetail',
                name: 'lawseadetail',
                component: () => import('../components/CustomerElement/LawyerSeaDetailView.vue'),
            },
            // 调解员客户管理
            {
                path: 'lawtotal',
                component: () => import('../components/CustomerElement/LawyerTotalView.vue'),
            },


            // 服务助理客户管理
            {
                path: 'assistant',
                component: () => import('../components/CustomerElement/LawassistantTotalView.vue'),
            },

            // 备注跟进
            {
                path: 'remarksFollow',
                name: 'remarksFollow',
                component: () => import('../components/CustomerElement/remarksFollow.vue'),
            },
            // 调解员客户查看
            {
                path: 'lawtotaldetail',
                name: 'lawtotaldetail',
                component: () => import('../components/CustomerElement/LawTotalDetailView.vue'),
            },

            // 案件管理
            {
                path: 'caselist',
                component: () => import('../components/CaseElement/CaseView.vue'),
            },
            // 案件详情
            {
                path: 'casedetail',
                name: 'casedetail',
                component: () => import('../components/CaseElement/RoundElement/CaseDatailView.vue'),
            },
            // 加急审核
            {
                path: 'urgent',
                component: () => import('../components/CaseElement/UrgentView.vue'),
            },
            // 加急审核详情
            {
                path: 'detail1',
                name: 'detail1',
                component: () => import('../components/CaseElement/components/DetailView.vue'),
            },
            // 搁置审核
            {
                path: 'shelve',
                component: () => import('../components/CaseElement/ShelveView.vue'),
            },
            // 调解审核
            {
                path: 'allcheck',
                component: () => import('../components/CaseElement/AllCheckView.vue'),
            },
            // 结果性审核
            {
                path: 'resultCheck',
                component: () => import('../components/CaseElement/resultCheckView.vue'),
            },
            // 调解审核
            {
                path: 'processQuality',
                component: () => import('../components/CaseElement/ProcessQualityView.vue'),
            },
            // 调解审核详情   预调解审核详情
            {
                path: 'alldetail',
                name: 'alldetail',
                component: () => import('../components/CaseElement/AllElement/AllDetailView.vue'),
            },
            // 预调解审核2.0
            {
                path: 'processQualityPreSecond',
                component: () => import('../components/CaseElement/ProcessQualityViewPreSecond.vue'),
            },
            {
                path: 'processQualityPre',
                component: () => import('../components/CaseElement/ProcessQualityViewPre.vue'),
            },
            // 债务分析
            {
                path: 'rolloverDebtAnalyze',
                component: () => import('../components/CaseElement/rolloverDebtAnalyze.vue'),
            },
            {
                path: 'Rights',
                name: 'Rights',
                component: () => import('../components/CaseElement/Rights.vue'),
            },
            //维权详情
            {
                path: 'Rightsdetail',
                name: 'Rightsdetail',
                component: () => import('../components/CaseElement/RightsElement/Rightsdetail.vue'),
            },
            //协议审核
            {
                path: 'agreement',
                name: 'agreement',
                component: () => import('../components/CaseElement/agreement.vue'),
            },
            //协议审核
            {
                path: 'Relief',
                name: 'Relief',
                component: () => import('../components/CaseElement/Relief.vue'),
            },
            {
                path: 'Pre_litigation',
                name: 'Pre_litigation',
                component: () => import('../components/Audit/Pre_litigation.vue'),
            },
            {
                path: 'lawsuit',
                name: 'lawsuit',
                component: () => import('../components/Audit/lawsuit.vue'),
            },
            {
                path: 'execute',
                name: 'execute',
                component: () => import('../components/Audit/execute.vue'),
            },
            {
                path: 'auditdetail',
                name: 'auditdetail',
                component: () => import('../components/Audit/auditdetail.vue'),
            },
            {
                path: 'shelvedetail',
                name: 'shelvedetail',
                component: () => import('../components/CaseElement/ShelveElement/ShelveDetailView.vue'),
            },

            // 财务管理 === 订单管理
            {
                path: 'order',
                component: () => import('../components/OrderElement/OrderView.vue'),
            },
            // 财务管理 === 退款管理
            {
                path: 'refund',
                component: () => import('../components/OrderElement/RefundView.vue'),
            },
            // 订单详情
            {
                path: 'detail',
                name: 'detail',
                component: () => import('../components/OrderElement/DetailView.vue'),
            },
            // 退款订单详情
            {
                path: 'refundDetail',
                name: 'refundDetail',
                component: () => import('../components/OrderElement/RefundDetailView.vue'),
            },
            // 补录订单
            {
                path: 'check',
                component: () => import('../components/OrderElement/CheckView.vue'),
            },
            // 订单详情
            {
                path: 'checkdetail',
                name: "checkdetail",
                component: () => import('../components/OrderElement/components/CheckDetailView.vue'),
            },
            // 短信记录详情
            {
                path: 'msgDetail',
                name: "msgDetail",
                component: () => import('../components/MessageElement/components/msgDetailView.vue'),
            },

            // 权限管理 === 组织架构管理
            {
                path: 'team',
                component: () => import('../components/AuthorityElement/TeamView.vue'),

            },
            // 权限管理 === 账号管理
            {
                path: 'account',
                component: () => import('../components/AuthorityElement/AccountView.vue'),
            },

            // 短信管理 === 发送记录
            {
                path: 'sendMessage',
                component: () => import('../components/MessageElement/SendMessageView.vue'),
            },
            // 短信管理 === 新建发送
            {
                path: 'creatMessage',
                component: () => import('../components/MessageElement/CreatMessageView.vue'),
            },
            // 短信管理 === 发送记录
            // {
            //     path: 'messageRecords',
            //     component: () => import('../components/MessageElement/MessageRecordsView.vue'),
            // },
            // 标签管理 === 新建标签
            {
                path: 'createTag',
                component: () => import('../components/TagElement/CreateTagView.vue'),
            },

            {
                path: 'auditmanage',
                component: () => import('../components/AuditElement/AuditManage.vue'),
            },
            {
                path: 'transferof',
                component: () => import('../components/TransferofElement/AuditManage.vue'),
            },
            {
                path: 'auditManageDetail',
                component: () => import('../components/AuditElement/AuditManageDetailView.vue'),
            },
            {
                path: 'appchat',
                component: () => import('../components/Audit/appchat.vue'),
            },
            {
                path: 'Credit',
                component: () => import('../components/Audit/Credit.vue'),
            },
            {
                path: 'loan',
                component: () => import('../components/Audit/loan.vue'),
            },

            {
                path: "Tobeassigned",
                name: "Tobeassigned",
                component: () => import("../components/Tobeassigned/list.vue")
            },
            {
                path: "editassigned",
                name: "editassigned",
                component: () => import("../components/Tobeassigned/edit.vue")
            },
            {
                path: "report_list",
                name: "report_list",
                component: () => import("../components/Tobeassigned/report_list.vue")
            },
        ]
    }
]
const router = createRouter({
    history: createWebHistory(),
    routes
})

export default router
